import { Link, useNavigate } from "react-router-dom";
import { AUTH } from "@/lib/api";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_instant-menu-preview/artifacts/9yxh3mar_neural.logo%20%281%29.png";

export default function Nav({ children, sticky = true }) {
  const nav = useNavigate();
  const user = AUTH.user();
  return (
    <header className={`${sticky ? "sticky top-0 z-40" : ""} bg-background/85 backdrop-blur-md border-b border-border`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-12 py-4">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-home">
          <img src={LOGO_URL} alt="ordrs" className="h-7 w-auto" style={{filter:"none"}}/>
        </Link>
        <nav className="flex items-center gap-3 sm:gap-5 text-sm font-medium">
          <Link to="/demo" className="hidden sm:inline hover:text-primary transition-colors" data-testid="nav-demo">Demo</Link>
          <Link to="/gallery" className="hidden sm:inline hover:text-primary transition-colors" data-testid="nav-gallery">Gallery</Link>
          <Link to="/pricing" className="hidden sm:inline hover:text-primary transition-colors" data-testid="nav-pricing">Pricing</Link>
          {children}
          {user ? (
            <>
              <Link to="/account" className="hover:text-primary transition-colors" data-testid="nav-account">{user.name?.split(" ")[0] || "Account"}</Link>
              <Button size="sm" variant="ghost" onClick={() => { AUTH.clear(); nav("/"); }} data-testid="nav-logout">Sign out</Button>
            </>
          ) : (
            <Link to="/signup" data-testid="nav-signup"><Button size="sm">Start free</Button></Link>
          )}
        </nav>
      </div>
    </header>
  );
}
